import React from 'react'
import FormWrapper from '../../../layout/formLayout/FormWrapper'
import Header from '../../../components/form/Header'
import RegistrationForm from '../../../components/collage/auth/Registration'

export default function Registration() {
   
    
    return (
        <>
            <FormWrapper >
                <div className=''>
                    <Header title="Register College Here"/>
                    <RegistrationForm/>
                </div>
            </FormWrapper>
        </>
    )
}
